import '../css/app.css'

import Alpine from 'alpinejs'
import collapse from '@alpinejs/collapse'
import focus from '@alpinejs/focus'
import registerSubNav from './sub-nav.js'
import initBackToTop from './back-to-top.js'

Alpine.plugin(collapse)
Alpine.plugin(focus)
registerSubNav(Alpine)
window.Alpine = Alpine
Alpine.start()
initBackToTop()

import '@tailwindplus/elements'
import Splide from '@splidejs/splide'

import LazyLoad from 'vanilla-lazyload'

import 'leaflet/dist/leaflet.js'

var lazyLoadInstance = new LazyLoad({})
lazyLoadInstance.update()

let anchorLinks = document.querySelectorAll('a')
for (let i = 0; i < anchorLinks.length; i += 1) {
  if (anchorLinks[i].host !== window.location.hostname) {
    anchorLinks[i].setAttribute('target', '_blank')
  }
}

var elmsTestimonials = document.getElementsByClassName('carousel-splide-testimonials')

for (var iTestimonials = 0; iTestimonials < elmsTestimonials.length; iTestimonials++) {
  new Splide(elmsTestimonials[iTestimonials], {
    autoplay: false,
    type: 'slide',
    pagination: true,
    perPage: 2,
    perMove: 1,
    trimSpace: false,
    arrows: true,
    gap: '2rem',
    padding: { left: 10, right: 0 },
    fixedWidth: '378px',
    breakpoints: {
      1535: { perPage: 2, perMove: 1, gap: '2rem', fixedWidth: '378px' },
      1343: { perPage: 2, perMove: 1, gap: '2rem', fixedWidth: '378px' },
      1279: { perPage: 2, perMove: 1, gap: '2rem', fixedWidth: '40%' },
      1023: { perPage: 1, perMove: 1, gap: '2rem', fixedWidth: '40%' },
      767: { perPage: 1, perMove: 1, gap: '2rem', fixedWidth: '340px' },
    },
  }).mount()
}

if (import.meta.hot) {
  import.meta.hot.accept()
}
